import { render, staticRenderFns } from "./SwapModal.vue?vue&type=template&id=25567c24&"
import script from "./SwapModal.vue?vue&type=script&lang=js&"
export * from "./SwapModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports